<template>
<div class="box-container tgui-poster" v-show="showStatus">
    <div class="box-row marginb20" :data-type="'poster_'+item.props.type" v-for="item in data">
        <!-- <div class="box-row" :class="{marginb10:$index!=data.length-1}" v-for="item in data"> -->
        <!-- 广告位头部 -->
        <div  class="bg-white tgui-posterHead flex-container left" data-type="title" v-if="item.imageUrl||item.title">
            <div class="img-container marginr10" style="width:20px;height:20px" v-if="item.imageUrl">
                <img :src="item.imageUrl" alt="">
            </div>
            <div class="flex1" :class="item.subTitle?'paddingt10 paddingb20':''">
                <div :style="item.subTitle ? '' : 'line-height: 40px;'" v-text="item.title"></div>
                <div class="fs-11 text-light" v-if="item.subTitle" v-text="item.subTitle"></div>
            </div>
        </div>
        <!-- 广告位主体 -->
        <div v-if="[1,68,310].includes(item.props.type)" class="clearfix bg-white adposter_{{item.props.type}}">
<!--            <a data-scp="one.0" data-bk="{{item.items[0].bk}}" href="{{item.items[0].clickUrl||nolink}}"><img :src="item.items[0].imageUrl" alt="" width="100%"></a>-->
	        <tg-wx-launch-poster :data="item.items[0]" scp="one.0" :bk="item.items[0].bk" width="100%"></tg-wx-launch-poster>
        </div>
	    <div v-if="item.props.type===135" class="clearfix bg-white adposter_{{item.props.type}} margin:auto;">
<!--            <a data-scp="one.0" data-bk="{{item.items[0].bk}}" href="{{item.items[0].clickUrl||nolink}}"><img :src="item.items[0].imageUrl" alt="" width="100%"></a>-->
		    <tg-wx-launch-poster :data="item.items[0]" scp="one.0" :bk="item.items[0].bk"></tg-wx-launch-poster>
	    </div>
        <div v-if="item.props.type==2 || item.props.type==4 || item.props.type==77"  class="clearfix bg-white">
            <cmui-list :col="2" :border="true">
                <cmui-list-item v-for="i in item.items">
                    <a data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}" data-bk="{{i.bk}}" href="{{i.clickUrl||nolink}}">
                        <img :src="i.imageUrl" alt="">
                    </a>
                </cmui-list-item>
            </cmui-list>
        </div>
        <div v-if="item.props.type==3"  class="flex-container bg-white">
            <cmui-list :col="2" :border="true">
                <cmui-list-item>
                    <a data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" href="{{item.items[0].clickUrl||nolink}}"><img :src="item.items[0].imageUrl" alt="" width="100%"></a>
                </cmui-list-item>
                <cmui-list-item>
                    <cmui-list :col="1" :border="true">
                        <cmui-list-item>
                            <a data-scp="ad_{{item.id}}_{{item.items[1].id}}.1" data-bk="{{item.items[1].bk}}" href="{{item.items[1].clickUrl||nolink}}"><img :src="item.items[1].imageUrl" alt="" width="100%"></a>
                        </cmui-list-item>
                        <cmui-list-item>
                            <a data-scp="ad_{{item.id}}_{{item.items[2].id}}.2" data-bk="{{item.items[2].bk}}" href="{{item.items[2].clickUrl||nolink}}"><img :src="item.items[2].imageUrl" alt="" width="100%"></a>
                        </cmui-list-item>
                    </cmui-list>
                </cmui-list-item>
            </cmui-list>
        </div> 
        <div v-if="item.props.type==6 || item.props.type==9|| item.props.type==106"  class="clearfix bg-white">
            <cmui-list :col="3" :border="item.props.type!=106">
                <cmui-list-item v-for="i in item.items">
                    <a data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}" data-bk="{{i.bk}}" href="{{i.clickUrl||nolink}}"><img :src="i.imageUrl" alt="" width="100%"></a>
                </cmui-list-item>
            </cmui-list>
        </div>
        <div v-if="item.props.type==5" class="clearfix bg-white">
            <cmui-list :col="[3,5]" :border="true">
                <cmui-list-item>
                    <a data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" href="{{item.items[0].clickUrl||nolink}}"><img :src="item.items[0].imageUrl" alt="" width="100%"></a>
                </cmui-list-item>
                <cmui-list-item>
                    <cmui-list :col="1" :border="true">
                        <cmui-list-item>
                            <a data-scp="ad_{{item.id}}_{{item.items[1].id}}.1" data-bk="{{item.items[1].bk}}" href="{{item.items[1].clickUrl||nolink}}"><img :src="item.items[1].imageUrl" alt="" width="100%"></a>
                        </cmui-list-item>
                        <cmui-list-item>
                            <cmui-list :col="[37,43]" :border="true">
                                <cmui-list-item>
                                    <a data-scp="ad_{{item.id}}_{{item.items[2].id}}.2" data-bk="{{item.items[2].bk}}" href="{{item.items[2].clickUrl||nolink}}"><img :src="item.items[2].imageUrl" alt="" width="100%"></a>
                                </cmui-list-item>
                                <cmui-list-item>
                                    <a data-scp="ad_{{item.id}}_{{item.items[3].id}}.3" data-bk="{{item.items[3].bk}}" href="{{item.items[3].clickUrl||nolink}}"><img :src="item.items[3].imageUrl" alt="" width="100%"></a>
                                </cmui-list-item>
                            </cmui-list>
                        </cmui-list-item>
                    </cmui-list>
                </cmui-list-item>
            </cmui-list>
        </div>
        <div v-if="item.props.type==12"  class="clearfix bg-white">
            <cmui-list  :col="4" :border="true">
                <cmui-list-item v-for="i in item.items">
                    <a data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}" data-bk="{{i.bk}}" href="{{i.clickUrl||nolink}}"><img :src="i.imageUrl" alt="" width="100%"></a>
                </cmui-list-item>
            </cmui-list>
        </div>
        <div v-if="item.props.type==67" class="clearfix bg-white">
            <cmui-list :border="true" :col="[2,3]">
                <cmui-list-item>
                    <a data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" href="{{item.items[0].clickUrl||nolink}}"><img :src="item.items[0].imageUrl" alt="" width="100%" height="100%"></a>
                </cmui-list-item>
                <cmui-list-item>
                    <cmui-list :border="true">
                        <cmui-list-item>
                            <a data-scp="ad_{{item.id}}_{{item.items[1].id}}.1" data-bk="{{item.items[1].bk}}" href="{{item.items[1].clickUrl||nolink}}"><img :src="item.items[1].imageUrl" alt="" width="100%" height="100%"></a>
                        </cmui-list-item>
                        <cmui-list-item>
                            <cmui-list :col="2" :border="true">
                                <cmui-list-item>
                                    <a data-scp="ad_{{item.id}}_{{item.items[2].id}}.2" data-bk="{{item.items[2].bk}}" href="{{item.items[2].clickUrl||nolink}}"><img :src="item.items[2].imageUrl" alt="" width="100%" height="100%"></a>
                                </cmui-list-item>
                                <cmui-list-item>
                                    <a data-scp="ad_{{item.id}}_{{item.items[3].id}}.3" data-bk="{{item.items[3].bk}}" href="{{item.items[3].clickUrl||nolink}}"><img :src="item.items[3].imageUrl" alt="" width="100%" height="100%"></a>
                                </cmui-list-item>
                            </cmui-list>
                        </cmui-list-item>
                    </cmui-list>
                </cmui-list-item>
            </cmui-list>
        </div>
        <div v-if="item.props.type==69" class="clearfix bg-white paddingv20">
            <cmui-list :col="2" :space="20" class="paddingh20">
                <cmui-list-item>
                    <div class="img-container radius border">
                        <a :href="item.items[0].clickUrl" data-scp="ad_{{item.id}}_{{item.items[0].id}}.0"><img :src="item.items[0].imageUrl"></a>
                    </div>
                </cmui-list-item>
                <cmui-list-item>
                    <div class="img-container radius border">
                        <a :href="item.items[1].clickUrl" data-scp="ad_{{item.id}}_{{item.items[1].id}}.1"><img :src="item.items[1].imageUrl"></a>
                    </div>
                    <div class="img-container radius border margint20">
                        <a :href="item.items[2].clickUrl" data-scp="ad_{{item.id}}_{{item.items[2].id}}.2"><img :src="item.items[2].imageUrl"></a>
                    </div>
                </cmui-list-item>
            </cmui-list>
            <div class="padding20" v-show="item.items.length>3">
                <div class="border border-radius padding20">
                    <cmui-list :col="5" :space="20">
                        <cmui-list-item v-for="i in item.items" v-if="$index>2">
                            <a :href="i.clickUrl" data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}"><img :src="i.imageUrl"></a>
                        </cmui-list-item>
                    </cmui-list>
                </div>
            </div>
        </div>
        <div v-if="item.props.type==82" class="clearfix bg-white paddingv20">
            <a data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" :href="item.items[0].clickUrl"><img :src="item.items[0].imageUrl"></a>
            <div class="box-row">
                <a data-scp="ad_{{item.id}}_{{item.items[1].id}}.1" data-bk="{{item.items[1].bk}}" :href="item.items[1].clickUrl" class="box-span4"><img :src="item.items[1].imageUrl"></a>
                <a data-scp="ad_{{item.id}}_{{item.items[2].id}}.2" data-bk="{{item.items[2].bk}}" :href="item.items[2].clickUrl" class="box-span4"><img :src="item.items[2].imageUrl"></a>
                <a data-scp="ad_{{item.id}}_{{item.items[3].id}}.3" data-bk="{{item.items[3].bk}}" :href="item.items[3].clickUrl" class="box-span4"><img :src="item.items[3].imageUrl"></a>
            </div>
        </div>

        <div v-if="item.props.type==85" class="paddingh20 paddingb20 bg-white">
            <div class="flex-container border vfull">
                <div class="borderr flex-container vfull" style="width:40.57971014%">
                    <a class="flex-container-col flex1" data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" :href="item.items[0].clickUrl"><img :src="item.items[0].imageUrl" class="flex1"></a>
                </div>
                <div style="width:59.42028985%">
                    <div class="borderb">
                        <a data-scp="ad_{{item.id}}_{{item.items[1].id}}.1" data-bk="{{item.items[1].bk}}" :href="item.items[1].clickUrl"><img :src="item.items[1].imageUrl"></a>
                    </div>
                    <div class="flex-container vfull">
                        <div style="width:50.2%" class="flex-container vfull borderr">
                            <a class="flex-container-col" data-scp="ad_{{item.id}}_{{item.items[2].id}}.2" data-bk="{{item.items[2].bk}}" :href="item.items[2].clickUrl"><img :src="item.items[2].imageUrl" class="flex1"></a>
                        </div>
                        <div style="width:49.8%" class="flex-container vfull">
                            <a class="flex-container-col" data-scp="ad_{{item.id}}_{{item.items[3].id}}.3" data-bk="{{item.items[3].bk}}" :href="item.items[3].clickUrl"><img :src="item.items[3].imageUrl" class="flex1"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="item.props.type==86&&item.items.length>4" class="paddingb20 bg-white">
            <div>
                <a data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" :href="item.items[0].clickUrl" class="up pos-r dis-b"><img :src="item.items[0].imageUrl"></a>
            </div>
            <div class="scroll-container paddingr20" style="padding-bottom:2px;">
                <div v-for="inner in item.items.slice(1)" class="marginl20 margint20" style="width:100px;outline: 1px solid #ebebeb;">
                    <a data-scp="ad_{{item.id}}_{{inner.id}}.{{$index+1}}" data-bk="{{inner.bk}}" :href="inner.clickUrl"><img :src="inner.imageUrl"></a>
                </div>
            </div>
        </div>
        <!-- 口日 3宫格 广告位 -->
        <div v-if="item.props.type==100" class="bg-white adposter_{{item.props.type}}">
             <div class="flex-container border vfull">
                <div class="borderr flex-container vfull propsLeft" style="width:40.57971014%">
                    <a class="flex-container-col flex1" data-scp="ad_{{item.id}}_{{item.items[0].id}}.0" data-bk="{{item.items[0].bk}}" :href="item.items[0].clickUrl"><img :src="item.items[0].imageUrl" class="flex1" width="100%"></a>
                </div>
                <div class="propsRight" style="width:59.42028985%">
                    <div class="borderb">
                        <a data-scp="ad_{{item.id}}_{{item.items[1].id}}.1" data-bk="{{item.items[1].bk}}" :href="item.items[1].clickUrl"><img :src="item.items[1].imageUrl"></a>
                    </div>
                    <div class="flex-container vfull">
                        <div class="flex-container vfull borderr">
                            <a data-scp="ad_{{item.id}}_{{item.items[2].id}}.2" data-bk="{{item.items[2].bk}}" :href="item.items[2].clickUrl"><img :src="item.items[2].imageUrl" class="flex1"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 口口口 3宫格 -->
        <div v-if="item.props.type == 101" class="bg-white adposter_{{item.props.type}}">
            <div class="clearfix borderr">
                <div style="width:33.33333333%" class="float-left borderl bordert borderb" v-for="i in item.items">
                    <a data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}" data-bk="{{i.bk}}" href="{{i.clickUrl||nolink}}"><img :src="i.imageUrl" alt="" width="100%"></a>
                </div>
            </div>
        </div>
        <!-- 田 4宫格 -->
        <div v-if="item.props.type == 102" class="bg-white adposter_{{item.props.type}}">
            <div class="clearfix border">
                <div style="width:50%" class="float-left" v-for="i in item.items">
                    <a data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}" data-bk="{{i.bk}}" href="{{i.clickUrl||nolink}}"><img :src="i.imageUrl" alt="" width="100%" v-bind:class="{'borderr':!item.props.transparentLine&&$index%2==0,'bordert':!item.props.transparentLine&&$index>1}"></a>
                </div>
            </div>
        </div>
        <div v-if="item.props.type == 105" class="bg-white adposter_{{item.props.type}} paddingh20">
            <cmui-list :col="2" :space="20" :border="true">
                <cmui-list-item v-for="i in item.items">
                    <a :href="i.clickUrl" data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}"><img :src="i.imageUrl" alt=""></a>
                </cmui-list-item>
            </cmui-list>
        </div>
        <div v-if="item.props.type == 109" class="bg-white adposter_{{item.props.type}} paddingh20">
            <cmui-list :col="2" :border="true" class="border">
                <cmui-list-item v-for="i in item.items.slice(0,2)" class="bg-white">
                    <a :href="i.clickUrl" data-scp="ad_{{item.id}}_{{i.id}}.{{$index}}"><img :src="i.imageUrl" alt=""></a>
                </cmui-list-item>
            </cmui-list>
            <cmui-list :col="4" :border="true" class="border" style="margin-top:-1px;">
                <cmui-list-item v-for="i in item.items.slice(2)"  class="bg-white">
                    <a :href="i.clickUrl" data-scp="ad_{{item.id}}_{{i.id}}.{{$index+2}}"><img :src="i.imageUrl" alt=""></a>
                </cmui-list-item>
            </cmui-list>
        </div>
    </div>
    <!-- 统一结构测试代码 -->
    <!-- <pc-poster :data="item" v-for="item in realData"></pc-poster> -->
</div>
</template>
<style lang="scss">
    .tgui-poster [data-type*="poster_"]:last-child{
        margin-bottom:0;
    }
</style>
<script>
import pcPoster from './poster.vue';
import '../wxLaunch/index.js';
const CONFIG={
    85:{
        col:[2,3],
        items:[0,{
            items:[0,{col:2}]
        }]
    },
    105:{col:2,space:20,border:false}
}
function changeToTarget(target,source){
        if(target==0){
            return source.splice(0,1)[0]
        }
        if(target.border===undefined){
            target.border=true
        }
        if(_.isNumber(target.items)){
            target.items=source.splice(0,target.items);
        }else if(_.isArray(target.items)){
            _.forEach(target.items,(item,index)=>{
                target.items[index]=changeToTarget(item,source)
            })
        }else{
            target.items=source.splice(0)
        }
        console.log(target)
        return target
}
function format(data){
    let type=_.get(data,'props.type');
    let target=_.get(CONFIG,type)
    if(target){
        return changeToTarget(target,data.items)
    }else{
        return {};
    }
}
export default {
	props:{
		data:Array,
        theme:String
	},
    components:{
        'pc-poster':pcPoster
    },
    data(){
        return {
            nolink:'javascript:void(0)'
        }
    },
	computed:{
		showStatus:function(){
			return !!this.data.length
		},
        realData:function(){
            let rs=[];
            this.data.forEach(item=>{
                rs.push(format(item))
            })
            return rs
        }
	}
}
</script>